import React from "react";
import "./HTML_MAIN_CSS.css";

const HTMLTableColRow = () => {
  return (
    <div className="html-container">
      <h1>HTML Tables – Colspan & Rowspan</h1>

      {/* 1. Introduction */}
      <section id="introduction">
        <h2>1. Introduction</h2>
        <p>
          The <code>colspan</code> and <code>rowspan</code> attributes in HTML tables allow cells to span multiple columns or rows. This is useful for creating complex table layouts.
        </p>
      </section>

      {/* 2. Colspan */}
      <section id="colspan">
        <h2>2. Colspan</h2>
        <p>
          <code>colspan</code> allows a cell to extend across multiple columns:
        </p>
        <pre>
          <code>{`<table border="1">
  <tr>
    <th colspan="2">Name</th>
    <th>Age</th>
  </tr>
  <tr>
    <td>John</td>
    <td>Doe</td>
    <td>25</td>
  </tr>
  <tr>
    <td>Jane</td>
    <td>Smith</td>
    <td>30</td>
  </tr>
</table>`}</code>
        </pre>
        <p>
          Here, the first header cell spans two columns, merging "First" and "Last Name".
        </p>
      </section>

      {/* 3. Rowspan */}
      <section id="rowspan">
        <h2>3. Rowspan</h2>
        <p>
          <code>rowspan</code> allows a cell to extend across multiple rows:
        </p>
        <pre>
          <code>{`<table border="1">
  <tr>
    <th rowspan="2">Name</th>
    <th>Subject</th>
    <th>Score</th>
  </tr>
  <tr>
    <th>Math</th>
    <th>95</th>
  </tr>
  <tr>
    <td>John Doe</td>
    <td>Science</td>
    <td>88</td>
  </tr>
</table>`}</code>
        </pre>
        <p>
          The "Name" cell spans two rows, linking multiple subjects with the same student.
        </p>
      </section>

      {/* 4. Combining Colspan & Rowspan */}
      <section id="combined">
        <h2>4. Combining Colspan & Rowspan</h2>
        <p>
          You can use <code>colspan</code> and <code>rowspan</code> together to create complex tables:
        </p>
        <pre>
          <code>{`<table border="1">
  <tr>
    <th rowspan="2">Name</th>
    <th colspan="2">Marks</th>
  </tr>
  <tr>
    <th>Math</th>
    <th>Science</th>
  </tr>
  <tr>
    <td>John Doe</td>
    <td>95</td>
    <td>88</td>
  </tr>
  <tr>
    <td>Jane Smith</td>
    <td>90</td>
    <td>92</td>
  </tr>
</table>`}</code>
        </pre>
      </section>

      {/* 5. Best Practices */}
      <section id="best-practices">
        <h2>5. Best Practices</h2>
        <ul>
          <li>Use <code>colspan</code> and <code>rowspan</code> to simplify table design.</li>
          <li>Keep tables readable by not overusing spans.</li>
          <li>Combine spans carefully to maintain proper alignment.</li>
          <li>Use CSS for styling instead of outdated HTML attributes like <code>border</code> when possible.</li>
        </ul>
      </section>

      {/* 6. Summary */}
      <section id="summary">
        <h2>6. Summary</h2>
        <ul>
          <li><code>colspan</code>: merge cells horizontally across columns.</li>
          <li><code>rowspan</code>: merge cells vertically across rows.</li>
          <li>Useful for headers, grouping, and complex table layouts.</li>
          <li>Always test table structure for readability and alignment.</li>
        </ul>
      </section>
    </div>
  );
};

export default HTMLTableColRow;
